export enum ProductInscriptionStatus {
	ToDo = "ToDo",
	Ready = "Ready",
}
